<template>
  <div class="space-y-2">
    <div
      class="bg-background-neutral-onblock flex items-start space-x-2 rounded-xl px-4 py-3"
    >
      <TrainIcon
        v-if="isRailTransfer"
        class="text-text-neutral-primary h-6 w-6 shrink-0"
      />
      <svg
        v-else
        class="text-text-neutral-primary"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M11.501 3a1.283 1.283 0 1 0 0 2.565 1.283 1.283 0 0 0 0-2.565ZM8.22 4.283a3.283 3.283 0 1 1 6.565 0 3.283 3.283 0 0 1-6.565 0ZM8.903 9.117a2.773 2.773 0 0 1 1.961-.812h.148a1 1 0 1 1 0 2h-.148a.773.773 0 0 0-.546.226l-1.806 1.806a.414.414 0 0 0-.121.292v2.067a1 1 0 1 1-2 0v-2.067c0-.64.254-1.254.707-1.706l1.805-1.806Z"
          clip-rule="evenodd"
        />
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M11.449 11.493a2.773 2.773 0 0 1-1.293-1.683l-.038-.142a1 1 0 0 1 1.931-.52l.039.144a.773.773 0 0 0 .36.469l2.212 1.275c.095.055.208.07.314.042l1.996-.537a1 1 0 0 1 .519 1.932l-1.996.536a2.413 2.413 0 0 1-1.832-.24l-2.212-1.276ZM9.42 17.805l.613-4.332a.994.994 0 0 1 1.969.276l-.62 4.448a4.596 4.596 0 0 1-1.75 2.775l-1.753 1.315a1 1 0 0 1-1.2-1.6l1.753-1.315c.51-.383.863-.941.988-1.567Z"
          clip-rule="evenodd"
        />
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10.008 10.305a1 1 0 1 1 2 0v2.572c0 .954.382 1.87 1.061 2.54l1.875 1.852a4.125 4.125 0 0 1 1.208 2.917V22a1 1 0 0 1-2 0v-1.814a2.125 2.125 0 0 0-.622-1.502l-2.29-2.267a4.158 4.158 0 0 1-1.232-2.955v-3.157Z"
          clip-rule="evenodd"
        />
      </svg>
      <div>
        <p class="text-text-neutral-primary text-base font-medium">
          {{
            isRailTransfer
              ? t('railTransferCity', { city })
              : t('transferCity', { city })
          }}
        </p>
        <p v-if="duration" class="text-text-neutral-quaternary text-sm">
          {{ isRailTransfer ? t('railTransferTime', { duration }) : duration }}
        </p>
      </div>
    </div>
    <p
      v-if="hasRailDescription"
      class="text-text-neutral-quaternary px-4 text-sm"
    >
      {{
        t('railTransferDescription', {
          trainName: railTrainName,
          stationName: railStationName,
        })
      }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import TrainIcon from '../../../../assets/images/train.svg?component';

  const props = defineProps<{
    duration: string | null;
    city: string;
    isRailTransfer?: boolean;
    railTrainName?: string | null;
    railStationName?: string | null;
  }>();

  const { t } = useI18n();

  const hasRailDescription = computed(
    () =>
      Boolean(props.isRailTransfer) &&
      Boolean(props.railTrainName) &&
      Boolean(props.railStationName),
  );
</script>

<i18n src="../../config/locales.json"></i18n>
